module.exports = __webpack_public_path__ + "img/brown-wooden-table-with-chair-3097112.83e01c10.jpg";